import React from 'react';
import styles from './HeaderInputs.module.scss';

const HeaderInputs = ({ title, date, category, onTitleChange, onDateChange, onCategoryChange }) => {
  return (
    <div className={styles.headerInputs}>
      <div className={`${styles.inputGroup} ${styles.titleInput}`}>
        <label>Title</label>
        <input
          type="text"
          value={title}
          onChange={onTitleChange}
        />
      </div>
      
      <div className={styles.inputGroup}>
        <label>Date</label>
        <input
          type="text"
          value={date}
          onChange={onDateChange}
        />
      </div>
      
      <div className={styles.inputGroup}>
        <label>Category</label>
        <input
          type="text"
          value={category}
          onChange={onCategoryChange}
        />
      </div>
    </div>
  );
};

export default HeaderInputs; 